import React from 'react';

var FormContext = /*#__PURE__*/React.createContext({
  value: {},
  onChange: function onChange() {},
  errors: {},
  onError: function onError() {},
  showErrors: false,
  allErrors: false,
  animateErrors: false,
  disabled: false,
  readOnly: false
});
FormContext.displayName = "FormContext";
var FormContext$1 = FormContext;

export { FormContext$1 as default };
